
<template>
  <div class="portal__content claim__status">
    <div class="claim__item claim__item--path head">
      <lennoc-icon image="logo-icon" domClass="icon--logo" />
      <div class="claim__header">
        <p class="status">{{ getUiString(['claim_details', 'claim', 'current_status']) }}:</p>
        <h3 class="claim__item--title title--l">{{ currentClaim.ClaimStatusTitle }}</h3>
      </div>
      <div class="claim__content">
        <div class="text">{{ filterHtml(currentClaim.ClaimStatus) }}</div>
      </div>
    </div>
    <claim-status-tab-item
    v-for="doc in claimStatusDocuments"
    :key="doc.Id"
    :documentId="doc.Id"
    >
    </claim-status-tab-item>
  </div>
</template>

<script>
import ClaimStatusTabItem from '@/components/claims/ClaimStatusTabItem.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ClaimStatusTab',
  components: {
    ClaimStatusTabItem
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      currentClaim: 'claim/currentClaim',
      claimDocuments: 'claim/getClaimDocuments'
    }),
    claimStatusDocuments () {
      return this.claimDocuments.filter(d => d.DocumentAction !== 'QuoteCustomer')
    }
  },
  data () {
    return {
      error: false
    }
  },
  methods: {
    filterHtml (input) {
      if (input) {
        return input.replace(/<.+?>/g, '')
      }
      return ''
    }
  }
}
</script>
